// src/components/TimeBasesServices.jsx
import React, { useEffect, useState, useCallback } from 'react';
import GoogleMaps from '../layout/GoogleMaps';
import axios from 'axios';
import './contentPage.css';
import './timeBasedServices.css';
import { TbReload } from "react-icons/tb";

const TimeBasesServices = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL?.replace(/\/?$/, "/") || "";

    // Estados
    const [services, setServices] = useState([]);
    const [rutas, setRutas] = useState([]);
    const [recorridos, setRecorridos] = useState([]);
    const [filterText, setFilterText] = useState("");
    const [selectedId, setSelectedId] = useState(null);
    const [loading, setLoading] = useState(false);

    // Tokens
    const tokene = localStorage.getItem('tokene');
    const tokenc = localStorage.getItem('tokenc');
    const key = localStorage.getItem('key');

    // Traer datos de la API
    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const { data } = await axios.get(
                `${baseUrl}api/Servicios/Monitoreogrupal`,
                {
                    params: { tokene, token: tokenc },
                    headers: { Authorization: `Bearer ${key}` }
                }
            );
            setServices(data.AServiciosgrupal || []);
            setRutas(data.ARutagrupal || []);
            setRecorridos(data.ARecorridogrupal || []);
        } catch (err) {
            console.error("Error al cargar datos:", err);
        } finally {
            setLoading(false);
        }
    }, [baseUrl, tokene, tokenc, key]);

    // Montaje + refresco cada 20s
    useEffect(() => {
        fetchData();
        const interval = setInterval(fetchData, 20000);
        return () => clearInterval(interval);
    }, [fetchData]);

    // Filtrado de la lista
    const filteredServices = services.filter(s =>
        `${s.idreserva} ${s.datasociado} ${s.movil} ${s.estadoreserva}`
            .toLowerCase()
            .includes(filterText.toLowerCase())
    );

    // Servicios a mostrar en el mapa
    const displayedServices = selectedId
        ? services.filter(s => s.idreserva === selectedId)
        : filteredServices;

    // — Marcadores de VEHÍCULOS —
    const vehicleMarkers = displayedServices.map(s => ({
        id: `veh-${s.idreserva}`,
        lat: s.latasoc,
        lng: s.latlong,
        type: 'image',
        angle: s.angulo,
        // imageUrl: `media/${s.idestado}.png`,
        label: s.movil
    }));

    // — Marcadores de DESTINO (dirección) —
    const destinationMarkers = rutas
        .filter(r =>
            r.idreserva === selectedId &&
            r.latitude && r.longitude &&
            r.latitude !== 0 && r.longitude !== 0
        )
        .map(r => ({
            id: `dst-${r.idreserva}-${r.item}`,
            lat: r.latitude,
            lng: r.longitude,
            type: 'circle',
            // imageUrl: `media/icon-destino${r.item}.png`,
            label: r.direccion
        }));

    // Combinar ambos arrays en UNO solo
    const markers = [...vehicleMarkers, ...destinationMarkers];

    // — Polilíneas (recorrido) —
    const computePolylines = id => {
        const puntos = recorridos
            .filter(r =>
                r.idreserva === id &&
                r.latitude && r.longitude &&
                r.latitude !== 0 && r.longitude !== 0
            )
            .map(r => ({ lat: r.latitude, lng: r.longitude, estado: r.idestado }));

        if (puntos.length < 2) return [];
        const segments = [];
        let seg = [{ lat: puntos[0].lat, lng: puntos[0].lng }];
        let last = puntos[0].estado;

        for (let i = 1; i < puntos.length; i++) {
            const p = puntos[i];
            if (p.estado === last) {
                seg.push({ lat: p.lat, lng: p.lng });
            } else {
                if (seg.length >= 2) segments.push({ estado: last, path: seg });
                seg = [
                    { lat: puntos[i - 1].lat, lng: puntos[i - 1].lng },
                    { lat: p.lat, lng: p.lng }
                ];
                last = p.estado;
            }
        }
        if (seg.length >= 2) segments.push({ estado: last, path: seg });
        return segments;
    };
    const polylines = selectedId ? computePolylines(selectedId) : [];

    // Recarga manual
    const handleReload = () => {
        setFilterText("");
        setSelectedId(null);
        fetchData();
    };

    return (
        <div className="page">
            <div className="container-maps-list">
                {/* SIDEBAR */}
                <div className="list-driver">
                    {/* <div className="sidebar-header">
                        <h1>Operatividad de móviles</h1>
                        <div className="movil-count">
                            {filteredServices.length} móvil
                            {filteredServices.length !== 1 && "es"}
                        </div>
                    </div> */}

                    <div className="sidebar-content">
                        <div className="filters-block">
                            <input
                                className="input"
                                placeholder="🔍 Filtrar por reserva, nombre, estado…"
                                value={filterText}
                                onChange={e => setFilterText(e.target.value)}
                            />
                            <button className="btn-add" onClick={handleReload}>
                                <TbReload size={20} />
                            </button>
                        </div>
                    </div>

                    <div id="list">
                        {filteredServices.map(s => (
                            <div
                                key={s.idreserva}
                                className={`card ${selectedId === s.idreserva
                                    ? (s.idestado === 15 ? "selected-proceso" :
                                        s.idestado === 14 ? "selected-contacto" :
                                            s.idestado === 13 ? "selected-punto" :
                                                s.idestado === 12 ? "selected-camino" : ''
                                    )
                                    : "select"
                                    }`}
                                onClick={() => setSelectedId(s.idreserva)}
                            >
                                <div className='header-box'>
                                    <img className='header-img' src={s.imaasoc} alt="img conductor" />
                                    <h6 className="header-text">{s.datasociado} ({s.movil})</h6>
                                </div>

                                <div className="info">
                                    <p><strong>ID Reserva:</strong> {s.idreserva}</p>
                                    <p><strong>Estado:</strong> {s.estadoreserva}</p>
                                    <p><strong>Teléfono:</strong> {s.telefonop}</p>
                                    <p><strong>Placa:</strong> {s.nplaca}</p>
                                    <p><strong>Vehículo:</strong> {s.datmovil}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* MAPA */}
                <div id="map" style={{ position: 'relative', flex: 1 }}>
                    <GoogleMaps
                        markers={markers}
                        polylines={polylines}
                    />
                    {/* Leyenda */}
                    <div id="map-legend">
                        {/* <div className="map-legend-title">Leyenda</div> */}
                        <div className="legend-item">
                            <span className="legend-color en-camino" /> En camino
                        </div>
                        <div className="legend-item">
                            <span className="legend-color en-el-punto" /> Ubicado
                        </div>
                        <div className="legend-item">
                            <span className="legend-color en-contacto" /> Contactado
                        </div>
                        <div className="legend-item">
                            <span className="legend-color en-proceso" /> En proceso
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TimeBasesServices;